import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../api/AxiosApi';
import DashboardTap4Content from '../dashboard/dashboardTabs/tab4Content/DashboardTap4Content';
import DashboardInverterData from '../dashboard/dashboardTabs/tab5Content/DashboardInverterData';
import DashboardTab6 from '../dashboard/dashboardTabs/tab6ChartContent/DashboardTab6';
import PlantGeneration from '../dashboard/dashboardTabs/tab8ChartContent/PlantGeneration';
import Dashboard7Location from '../dashboard/dashboardTabs/tab7LocationContent/Dashboard7Location';
import DashboardKusumTab1 from './dashboardKusumTabs/DashboardKusumTab1';
import Tab10SldPlant from '../dashboard/dashboardTabs/tab10PlantSld/Tab10PlantSld';

import { GiFruitTree } from "react-icons/gi";
import { MdCo2 } from "react-icons/md";
import { MdOutlineCo2 } from "react-icons/md";
import MoneyPotli from "../../../../assets/img/basic/moneyPotli.jpg";
import { GiReceiveMoney } from "react-icons/gi";
import { AppThemeContext } from '../../../../context/AppThemeContext';
import { AuthenticationContext } from '../../../../context/AuthenticationContext';
import { getDateTimeForDashboardTab1 } from '../../../../utils';
import { MainSumApi } from '../../../../api/Api';
import Swal from 'sweetalert2';
import "./DashboardKusum.css"



export default function DashboardKusum() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    const { PrimaryColor } = useContext(AppThemeContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext)


    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)


    const [key, setKey] = useState('Main');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }



    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });

    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };


    useEffect(() => {
        fetchData();
    }, [sumCredentials]);

     useEffect(() => {
            if (LoggedInUserInfo?.Welcome_msg?.trim()) {
                Swal.fire({
                    icon: 'error',
                    title: 'Web Portal Subscription Status',
                    html: LoggedInUserInfo.Welcome_msg,
                    confirmButtonText: 'OK',
                    width: "25rem",
    
    
                    customClass: {
                        popup: 'custom-swal-popup',
                        title: 'custom-swal-title',
                        htmlContainer: 'custom-swal-html'
                    }
                });
            }
        }, [LoggedInUserInfo?.Welcome_msg]);
     

    useEffect(() => {
        if (key === "Geographical Location") {
            setTimeout(() => {
                const mapElement = document.querySelector(".leaflet-container");
                if (mapElement && mapElement._leaflet_map) {
                    mapElement._leaflet_map.invalidateSize();
                }
            }, 200);
        }
    }, [key]);


    return (
        <Box>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                {/* <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        Dashboard
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {location.pathname}
                    </NavLink>
                </Stack> */}

                {/* {mainData.map((item, index) => (
                    <Stack
                        key={index}
                        direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation"
                    >
                        <Typography variant="p"><span style={{ fontSize: "1.3rem", color: PrimaryColor }}><GiReceiveMoney /></span> Revenue Gains({LoggedInUserInfo?.CURRENCY}) &nbsp;<span style={{ color: PrimaryColor }}>{item.TOT_Rev !== undefined ? item.TOT_Rev : "N/A"}</span></Typography> &nbsp;&nbsp;&nbsp;
                        <Typography variant="p"><span style={{ fontSize: "1.4rem", color: PrimaryColor }}><MdOutlineCo2 style={{ width: "30px", height: "30px" }} /></span> Reduction &nbsp;<span style={{ color: PrimaryColor }}>{item.co2_ton !== undefined ? item.co2_ton : "N/A"}</span></Typography>&nbsp;&nbsp;&nbsp;
                        
                        <Typography variant="p"><span style={{ fontSize: "1.3rem", color: PrimaryColor }}><GiFruitTree /></span>Tree Saved &nbsp;<span style={{ color: PrimaryColor }}>{item.TOT_tree !== undefined ? item.TOT_tree : "N/A"}</span></Typography>

                    </Stack>
                ))} */}

                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >

                    <Tab eventKey="Main" title="Main">

                        {/* <DashboardTap4Content/> */}
                        <DashboardKusumTab1 />
                    </Tab>

                    <Tab eventKey="Inverter Details" title="Inverter Details">

                        <DashboardInverterData />
                    </Tab>

                    <Tab eventKey="Peak KW vs KWp" title="Peak KW vs KWp">

                        <DashboardTab6 />
                    </Tab>

                    <Tab eventKey="Plant Generation" title="Plant Generation">
                        <PlantGeneration />
                    </Tab>

                    <Tab eventKey="Plant SLD" title="Plant SLD">
                        <Tab10SldPlant />
                    </Tab>

                </Tabs>
            </Box>
        </Box>

    )
}
